"use client"
import React from 'react';
import styles from './Midbannersection.module.scss';
import { pushToDataLayer } from '@/helpers/gtag';
import UnivoImage from "@/components/common/UnivoImage";
import UnivoCarousel from "@/components/common/UnivoCarousel";
import { IMAGE_ASSETS } from "@/constants/images";

interface CardItem {
  id: number;
  image: string;
  title: string;
  description: string;
  buttonText: string;
  link: string;
  onClick?: () => void;
}

const AmityBanners: React.FC = () => {
  const cardData: CardItem[] = [
    {
      id: 1,
      image: IMAGE_ASSETS.midBannerRefer,
      title: "Refer Friends. Earn Rewards.",
      description: "Invite your friends to Amity Online and earn exciting rewards when they enroll successfully.",
      buttonText: "Refer Now",
      link: "/referral",
    },
    {
      id: 2,
      image: IMAGE_ASSETS.midBannerSchoolOfAi,
      title: "AI-Ready Career Programs",
      description: "Build future-ready skills with industry-aligned AI certifications and career-focused learning paths.",
      buttonText: "Explore AI Certifications",
      link: "https://schoolofai.amityonline.com?utm_source=amityonline&utm_medium=multibanner",
      onClick: () =>
        window?.webengage?.track("Explore Now Clicked", {
          event_name: "Explore Now Clicked",
          banner: "School Of AI",
        }),
    },
    {
      id: 3,
      image: IMAGE_ASSETS.midBannerFrameA,
      title: "Scholarships for Achievers",
      description: "Unlock exclusive scholarship opportunities designed to make quality education more accessible.",
      buttonText: "View Scholarships",
      link: "/scholarship",
    },
    {
      id: 4,
      image: IMAGE_ASSETS.midBannerFrameB,
      title: "Campus Merch Store",
      description: "Shop official Amity Online merchandise and represent your learner journey with pride.",
      buttonText: "Shop Now",
      link: "https://amityonlinecampusmerch.com",
      onClick: () => window?.webengage?.track("Shop Now Clicked"),
    },
  ];
  const callGA = (card) => {
     pushToDataLayer({
          event: "navigation_click",
          page_type: "Home Page",
          cta_text: card?.buttonText,
          page_url_custom:window.location.href,
          section_name:"Unlock More From AUO"
        })
  }

  const Card = ({ card }: { card: CardItem }) => (
    <div className={styles.card}>
      <UnivoImage
        src={card.image}
        alt={card.title}
        className={styles.cardImage}
        width={400}
        height={240}
        sizes="(max-width: 768px) 90vw, 400px"
        loading="lazy"
        fetchPriority="low"
      />
      <div className={styles.cardBody}>
        <h3 className={styles.cardTitle}>{card.title}</h3>
        <p className={styles.cardDescription}>{card.description}</p>
        <a
          href={card.link}
          className={styles.cardButton}
           onClick={() => {
    card.onClick?.();
    callGA(card);
  }}
          target='_blank'
          rel="noopener noreferrer"
        >
          {card.buttonText}
        </a>
      </div>
    </div>
  );

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Unlock More From Your Amity Online Experience</h2>
      <hr className={styles.divider} />

      {/* Desktop */}
      <div className={styles.cardGrid}>
        {cardData.map((card) => (
          <Card key={card.id} card={card} />
        ))}
      </div>

      {/* Mobile */}
      <div className={styles.mobileCarousel}>
        <UnivoCarousel preset="midBannerMobile">
          {cardData.map((card) => (
            <Card key={card.id} card={card} />
          ))}
        </UnivoCarousel>
      </div>
    </section>
  );
};

export default AmityBanners;
